function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty2(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty2(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import { e as Connector, _ as _defineProperty, j as _classPrivateFieldInitSpec, n as normalizeChainId, k as _classPrivateFieldGet, l as _classPrivateFieldSet, c as ConnectorNotFoundError, U as UserRejectedRequestError, R as ResourceUnavailableError, f as ChainNotConfiguredError, A as AddChainError, i as SwitchChainError, m as _classPrivateMethodInitSpec, o as _classPrivateMethodGet } from './base-b565d5d4.esm.js';
import create from 'zustand/vanilla';
import { subscribeWithSelector, persist } from 'zustand/middleware';
import { providers } from 'ethers';
import { getAddress, hexValue } from 'ethers/lib/utils';

function getInjectedName(ethereum) {
  var _ethereum$providers, _getName;

  if (!ethereum) return 'Injected';

  var getName = function getName(provider) {
    if (provider.isBraveWallet) return 'Brave Wallet';
    if (provider.isCoinbaseWallet) return 'Coinbase Wallet';
    if (provider.isExodus) return 'Exodus';
    if (provider.isFrame) return 'Frame';
    if (provider.isOpera) return 'Opera';
    if (provider.isTally) return 'Tally';
    if (provider.isTokenPocket) return 'TokenPocket';
    if (provider.isTokenary) return 'Tokenary';
    if (provider.isTrust) return 'Trust Wallet';
    if (provider.isMetaMask) return 'MetaMask';
  }; // Some injected providers detect multiple other providers and create a list at `ethers.providers`


  if ((_ethereum$providers = ethereum.providers) !== null && _ethereum$providers !== void 0 && _ethereum$providers.length) {
    var _names$; // Deduplicate names using Set
    // Coinbase Wallet puts multiple providers in `ethereum.providers`


    var nameSet = new Set();
    var unknownCount = 1;

    var _iterator = _createForOfIteratorHelper(ethereum.providers),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var provider = _step.value;
        var name = getName(provider);

        if (!name) {
          name = "Unknown Wallet #".concat(unknownCount);
          unknownCount += 1;
        }

        nameSet.add(name);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }

    var names = _toConsumableArray(nameSet);

    if (names.length) return names;
    return (_names$ = names[0]) !== null && _names$ !== void 0 ? _names$ : 'Injected';
  }

  return (_getName = getName(ethereum)) !== null && _getName !== void 0 ? _getName : 'Injected';
}

var shimDisconnectKey = 'injected.shimDisconnect';

var _provider = /*#__PURE__*/new WeakMap();

var _switchingChains = /*#__PURE__*/new WeakMap();

var InjectedConnector = /*#__PURE__*/function (_Connector) {
  _inherits(InjectedConnector, _Connector);

  var _super = _createSuper(InjectedConnector);

  function InjectedConnector() {
    var _this;

    _classCallCheck(this, InjectedConnector);

    var _ref4 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        chains = _ref4.chains,
        _ref4$options = _ref4.options,
        options = _ref4$options === void 0 ? {
      shimDisconnect: true
    } : _ref4$options;

    _this = _super.call(this, {
      chains: chains,
      options: options
    });

    _defineProperty(_assertThisInitialized(_this), "id", void 0);

    _defineProperty(_assertThisInitialized(_this), "name", void 0);

    _defineProperty(_assertThisInitialized(_this), "ready", typeof window != 'undefined' && !!window.ethereum);

    _classPrivateFieldInitSpec(_assertThisInitialized(_this), _provider, {
      writable: true,
      value: void 0
    });

    _classPrivateFieldInitSpec(_assertThisInitialized(_this), _switchingChains, {
      writable: true,
      value: void 0
    });

    _defineProperty(_assertThisInitialized(_this), "onAccountsChanged", function (accounts) {
      if (accounts.length === 0) _this.emit('disconnect');else _this.emit('change', {
        account: getAddress(accounts[0])
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onChainChanged", function (chainId) {
      var id = normalizeChainId(chainId);

      var unsupported = _this.isChainUnsupported(id);

      _this.emit('change', {
        chain: {
          id: id,
          unsupported: unsupported
        }
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onDisconnect", function () {
      var _this$options, _this$options2, _getClient$storage; // We need this as MetaMask can emit the "disconnect" event
      // upon switching chains. This workaround ensures that the
      // user currently isn't in the process of switching chains.


      if ((_this$options = _this.options) !== null && _this$options !== void 0 && _this$options.shimChainChangedDisconnect && _classPrivateFieldGet(_assertThisInitialized(_this), _switchingChains)) {
        _classPrivateFieldSet(_assertThisInitialized(_this), _switchingChains, false);

        return;
      }

      _this.emit('disconnect'); // Remove shim signalling wallet is disconnected


      if ((_this$options2 = _this.options) !== null && _this$options2 !== void 0 && _this$options2.shimDisconnect) (_getClient$storage = getClient().storage) === null || _getClient$storage === void 0 ? void 0 : _getClient$storage.removeItem(shimDisconnectKey);
    });

    var name = 'Injected';

    if (typeof window !== 'undefined') {
      var overrideName = options.name;
      var detectedName = getInjectedName(window.ethereum);
      if (overrideName) name = typeof overrideName === 'function' ? overrideName(detectedName) : overrideName;else name = typeof detectedName === 'string' ? detectedName : detectedName[0];
    }

    _this.id = 'injected';
    _this.name = name;
    return _this;
  }

  _createClass(InjectedConnector, [{
    key: "connect",
    value: function () {
      var _connect = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var _ref5,
            chainId,
            _this$options3,
            _getClient$storage2,
            provider,
            account,
            id,
            unsupported,
            chain,
            _args = arguments;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _ref5 = _args.length > 0 && _args[0] !== undefined ? _args[0] : {}, chainId = _ref5.chainId;
                _context.prev = 1;
                _context.next = 4;
                return this.getProvider();

              case 4:
                provider = _context.sent;

                if (provider) {
                  _context.next = 7;
                  break;
                }

                throw new ConnectorNotFoundError();

              case 7:
                if (provider.on) {
                  provider.on('accountsChanged', this.onAccountsChanged);
                  provider.on('chainChanged', this.onChainChanged);
                  provider.on('disconnect', this.onDisconnect);
                }

                this.emit('message', {
                  type: 'connecting'
                });
                _context.next = 11;
                return this.getAccount();

              case 11:
                account = _context.sent;
                _context.next = 14;
                return this.getChainId();

              case 14:
                id = _context.sent;
                unsupported = this.isChainUnsupported(id);

                if (!(chainId && id !== chainId)) {
                  _context.next = 22;
                  break;
                }

                _context.next = 19;
                return this.switchChain(chainId);

              case 19:
                chain = _context.sent;
                id = chain.id;
                unsupported = this.isChainUnsupported(id);

              case 22:
                // Add shim to storage signalling wallet is connected
                if ((_this$options3 = this.options) !== null && _this$options3 !== void 0 && _this$options3.shimDisconnect) (_getClient$storage2 = getClient().storage) === null || _getClient$storage2 === void 0 ? void 0 : _getClient$storage2.setItem(shimDisconnectKey, true);
                return _context.abrupt("return", {
                  account: account,
                  chain: {
                    id: id,
                    unsupported: unsupported
                  },
                  provider: provider
                });

              case 26:
                _context.prev = 26;
                _context.t0 = _context["catch"](1);

                if (!this.isUserRejectedRequestError(_context.t0)) {
                  _context.next = 30;
                  break;
                }

                throw new UserRejectedRequestError(_context.t0);

              case 30:
                if (!(_context.t0.code === -32002)) {
                  _context.next = 32;
                  break;
                }

                throw new ResourceUnavailableError(_context.t0);

              case 32:
                throw _context.t0;

              case 33:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[1, 26]]);
      }));

      function connect() {
        return _connect.apply(this, arguments);
      }

      return connect;
    }()
  }, {
    key: "disconnect",
    value: function () {
      var _disconnect = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var _this$options4, _getClient$storage3, provider;

        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return this.getProvider();

              case 2:
                provider = _context2.sent;

                if (provider !== null && provider !== void 0 && provider.removeListener) {
                  _context2.next = 5;
                  break;
                }

                return _context2.abrupt("return");

              case 5:
                provider.removeListener('accountsChanged', this.onAccountsChanged);
                provider.removeListener('chainChanged', this.onChainChanged);
                provider.removeListener('disconnect', this.onDisconnect); // Remove shim signalling wallet is disconnected

                if ((_this$options4 = this.options) !== null && _this$options4 !== void 0 && _this$options4.shimDisconnect) (_getClient$storage3 = getClient().storage) === null || _getClient$storage3 === void 0 ? void 0 : _getClient$storage3.removeItem(shimDisconnectKey);

              case 9:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function disconnect() {
        return _disconnect.apply(this, arguments);
      }

      return disconnect;
    }()
  }, {
    key: "getAccount",
    value: function () {
      var _getAccount = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var provider, accounts;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return this.getProvider();

              case 2:
                provider = _context3.sent;

                if (provider) {
                  _context3.next = 5;
                  break;
                }

                throw new ConnectorNotFoundError();

              case 5:
                _context3.next = 7;
                return provider.request({
                  method: 'eth_requestAccounts'
                });

              case 7:
                accounts = _context3.sent;
                return _context3.abrupt("return", getAddress(accounts[0]));

              case 9:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function getAccount() {
        return _getAccount.apply(this, arguments);
      }

      return getAccount;
    }()
  }, {
    key: "getChainId",
    value: function () {
      var _getChainId = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var provider;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return this.getProvider();

              case 2:
                provider = _context4.sent;

                if (provider) {
                  _context4.next = 5;
                  break;
                }

                throw new ConnectorNotFoundError();

              case 5:
                _context4.next = 7;
                return provider.request({
                  method: 'eth_chainId'
                }).then(normalizeChainId);

              case 7:
                return _context4.abrupt("return", _context4.sent);

              case 8:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function getChainId() {
        return _getChainId.apply(this, arguments);
      }

      return getChainId;
    }()
  }, {
    key: "getProvider",
    value: function () {
      var _getProvider = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                if (typeof window !== 'undefined' && !!window.ethereum) _classPrivateFieldSet(this, _provider, window.ethereum);
                return _context5.abrupt("return", _classPrivateFieldGet(this, _provider));

              case 2:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function getProvider() {
        return _getProvider.apply(this, arguments);
      }

      return getProvider;
    }()
  }, {
    key: "getSigner",
    value: function () {
      var _getSigner = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
        var _yield$Promise$all, _yield$Promise$all2, provider, account;

        return regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.next = 2;
                return Promise.all([this.getProvider(), this.getAccount()]);

              case 2:
                _yield$Promise$all = _context6.sent;
                _yield$Promise$all2 = _slicedToArray(_yield$Promise$all, 2);
                provider = _yield$Promise$all2[0];
                account = _yield$Promise$all2[1];
                return _context6.abrupt("return", new providers.Web3Provider(provider).getSigner(account));

              case 7:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function getSigner() {
        return _getSigner.apply(this, arguments);
      }

      return getSigner;
    }()
  }, {
    key: "isAuthorized",
    value: function () {
      var _isAuthorized = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7() {
        var _this$options5, _getClient$storage4, provider, accounts, account;

        return regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _context7.prev = 0;

                if (!((_this$options5 = this.options) !== null && _this$options5 !== void 0 && _this$options5.shimDisconnect && // If shim does not exist in storage, wallet is disconnected
                !((_getClient$storage4 = getClient().storage) !== null && _getClient$storage4 !== void 0 && _getClient$storage4.getItem(shimDisconnectKey)))) {
                  _context7.next = 3;
                  break;
                }

                return _context7.abrupt("return", false);

              case 3:
                _context7.next = 5;
                return this.getProvider();

              case 5:
                provider = _context7.sent;

                if (provider) {
                  _context7.next = 8;
                  break;
                }

                throw new ConnectorNotFoundError();

              case 8:
                _context7.next = 10;
                return provider.request({
                  method: 'eth_accounts'
                });

              case 10:
                accounts = _context7.sent;
                account = accounts[0];
                return _context7.abrupt("return", !!account);

              case 15:
                _context7.prev = 15;
                _context7.t0 = _context7["catch"](0);
                return _context7.abrupt("return", false);

              case 18:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this, [[0, 15]]);
      }));

      function isAuthorized() {
        return _isAuthorized.apply(this, arguments);
      }

      return isAuthorized;
    }()
  }, {
    key: "switchChain",
    value: function () {
      var _switchChain = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8(chainId) {
        var _this$options6, provider, id, _this$chains$find, _data, _data$originalError, chain, _chain$rpcUrls$public;

        return regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                if ((_this$options6 = this.options) !== null && _this$options6 !== void 0 && _this$options6.shimChainChangedDisconnect) _classPrivateFieldSet(this, _switchingChains, true);
                _context8.next = 3;
                return this.getProvider();

              case 3:
                provider = _context8.sent;

                if (provider) {
                  _context8.next = 6;
                  break;
                }

                throw new ConnectorNotFoundError();

              case 6:
                id = hexValue(chainId);
                _context8.prev = 7;
                _context8.next = 10;
                return provider.request({
                  method: 'wallet_switchEthereumChain',
                  params: [{
                    chainId: id
                  }]
                });

              case 10:
                return _context8.abrupt("return", (_this$chains$find = this.chains.find(function (x) {
                  return x.id === chainId;
                })) !== null && _this$chains$find !== void 0 ? _this$chains$find : {
                  id: chainId,
                  name: "Chain ".concat(id),
                  network: "".concat(id),
                  rpcUrls: {
                    "default": ''
                  }
                });

              case 13:
                _context8.prev = 13;
                _context8.t0 = _context8["catch"](7);
                chain = this.chains.find(function (x) {
                  return x.id === chainId;
                });

                if (chain) {
                  _context8.next = 18;
                  break;
                }

                throw new ChainNotConfiguredError();

              case 18:
                if (!(_context8.t0.code === 4902 || // Unwrapping for MetaMask Mobile
                // https://github.com/MetaMask/metamask-mobile/issues/2944#issuecomment-976988719
                (_context8.t0 === null || _context8.t0 === void 0 ? void 0 : (_data = _context8.t0.data) === null || _data === void 0 ? void 0 : (_data$originalError = _data.originalError) === null || _data$originalError === void 0 ? void 0 : _data$originalError.code) === 4902)) {
                  _context8.next = 30;
                  break;
                }

                _context8.prev = 19;
                _context8.next = 22;
                return provider.request({
                  method: 'wallet_addEthereumChain',
                  params: [{
                    chainId: id,
                    chainName: chain.name,
                    nativeCurrency: chain.nativeCurrency,
                    rpcUrls: [(_chain$rpcUrls$public = chain.rpcUrls["public"]) !== null && _chain$rpcUrls$public !== void 0 ? _chain$rpcUrls$public : chain.rpcUrls["default"]],
                    blockExplorerUrls: this.getBlockExplorerUrls(chain)
                  }]
                });

              case 22:
                return _context8.abrupt("return", chain);

              case 25:
                _context8.prev = 25;
                _context8.t1 = _context8["catch"](19);

                if (!this.isUserRejectedRequestError(_context8.t1)) {
                  _context8.next = 29;
                  break;
                }

                throw new UserRejectedRequestError(_context8.t0);

              case 29:
                throw new AddChainError();

              case 30:
                if (!this.isUserRejectedRequestError(_context8.t0)) {
                  _context8.next = 32;
                  break;
                }

                throw new UserRejectedRequestError(_context8.t0);

              case 32:
                throw new SwitchChainError(_context8.t0);

              case 33:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, this, [[7, 13], [19, 25]]);
      }));

      function switchChain(_x) {
        return _switchChain.apply(this, arguments);
      }

      return switchChain;
    }()
  }, {
    key: "watchAsset",
    value: function () {
      var _watchAsset = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee9(_ref) {
        var address, _ref$decimals, decimals, image, symbol, provider;

        return regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                address = _ref.address, _ref$decimals = _ref.decimals, decimals = _ref$decimals === void 0 ? 18 : _ref$decimals, image = _ref.image, symbol = _ref.symbol;
                _context9.next = 3;
                return this.getProvider();

              case 3:
                provider = _context9.sent;

                if (provider) {
                  _context9.next = 6;
                  break;
                }

                throw new ConnectorNotFoundError();

              case 6:
                _context9.next = 8;
                return provider.request({
                  method: 'wallet_watchAsset',
                  params: {
                    type: 'ERC20',
                    options: {
                      address: address,
                      decimals: decimals,
                      image: image,
                      symbol: symbol
                    }
                  }
                });

              case 8:
                return _context9.abrupt("return", _context9.sent);

              case 9:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, this);
      }));

      function watchAsset(_x2) {
        return _watchAsset.apply(this, arguments);
      }

      return watchAsset;
    }()
  }, {
    key: "isUserRejectedRequestError",
    value: function isUserRejectedRequestError(error) {
      return error.code === 4001;
    }
  }]);

  return InjectedConnector;
}(Connector);

var noopStorage = {
  getItem: function getItem(_key) {
    return '';
  },
  setItem: function setItem(_key, _value) {
    return null;
  },
  removeItem: function removeItem(_key) {
    return null;
  }
};

function createStorage(_ref) {
  var storage = _ref.storage,
      _ref$key = _ref.key,
      prefix = _ref$key === void 0 ? 'wagmi' : _ref$key;
  return _objectSpread(_objectSpread({}, storage), {}, {
    getItem: function getItem(key) {
      var defaultState = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var value = storage.getItem("".concat(prefix, ".").concat(key));

      try {
        return value ? JSON.parse(value) : defaultState;
      } catch (error) {
        console.warn(error);
        return defaultState;
      }
    },
    setItem: function setItem(key, value) {
      if (value === null) {
        storage.removeItem("".concat(prefix, ".").concat(key));
      } else {
        try {
          storage.setItem("".concat(prefix, ".").concat(key), JSON.stringify(value));
        } catch (err) {
          console.error(err);
        }
      }
    },
    removeItem: function removeItem(key) {
      return storage.removeItem("".concat(prefix, ".").concat(key));
    }
  });
}

var storeKey = 'store';

var _isAutoConnecting = /*#__PURE__*/new WeakMap();

var _lastUsedConnector = /*#__PURE__*/new WeakMap();

var _addEffects = /*#__PURE__*/new WeakSet();

var Client = /*#__PURE__*/function () {
  function Client(_ref) {
    _classCallCheck(this, Client);

    var _ref$autoConnect = _ref.autoConnect,
        autoConnect = _ref$autoConnect === void 0 ? false : _ref$autoConnect,
        _ref$connectors = _ref.connectors,
        connectors = _ref$connectors === void 0 ? [new InjectedConnector()] : _ref$connectors,
        _provider = _ref.provider,
        _ref$storage = _ref.storage,
        storage = _ref$storage === void 0 ? createStorage({
      storage: typeof window !== 'undefined' ? window.localStorage : noopStorage
    }) : _ref$storage,
        _webSocketProvider = _ref.webSocketProvider;

    _classPrivateMethodInitSpec(this, _addEffects);

    _defineProperty(this, "config", void 0);

    _defineProperty(this, "storage", void 0);

    _defineProperty(this, "store", void 0);

    _classPrivateFieldInitSpec(this, _isAutoConnecting, {
      writable: true,
      value: void 0
    });

    _classPrivateFieldInitSpec(this, _lastUsedConnector, {
      writable: true,
      value: void 0
    }); // Check status for autoConnect flag


    var status = 'disconnected';

    var _chainId;

    if (autoConnect) {
      try {
        var _JSON$parse, _JSON$parse$state, _data$chain;

        var rawState = storage.getItem(storeKey, '');
        var data = (_JSON$parse = JSON.parse(rawState || '{}')) === null || _JSON$parse === void 0 ? void 0 : (_JSON$parse$state = _JSON$parse.state) === null || _JSON$parse$state === void 0 ? void 0 : _JSON$parse$state.data; // If account exists in localStorage, set status to reconnecting

        status = data !== null && data !== void 0 && data.account ? 'reconnecting' : 'connecting';
        _chainId = data === null || data === void 0 ? void 0 : (_data$chain = data.chain) === null || _data$chain === void 0 ? void 0 : _data$chain.id; // eslint-disable-next-line no-empty
      } catch (_error) {}
    } // Create store


    this.store = create(subscribeWithSelector(persist(function () {
      return {
        connectors: typeof connectors === 'function' ? connectors() : connectors,
        provider: typeof _provider === 'function' ? _provider({
          chainId: _chainId
        }) : _provider,
        status: status,
        webSocketProvider: typeof _webSocketProvider === 'function' ? _webSocketProvider({
          chainId: _chainId
        }) : _webSocketProvider
      };
    }, {
      name: storeKey,
      getStorage: function getStorage() {
        return storage;
      },
      partialize: function partialize(state) {
        var _state$data, _state$data2;

        return _objectSpread(_objectSpread({}, autoConnect && {
          data: {
            account: state === null || state === void 0 ? void 0 : (_state$data = state.data) === null || _state$data === void 0 ? void 0 : _state$data.account,
            chain: state === null || state === void 0 ? void 0 : (_state$data2 = state.data) === null || _state$data2 === void 0 ? void 0 : _state$data2.chain
          }
        }), {}, {
          chains: state === null || state === void 0 ? void 0 : state.chains
        });
      },
      version: 1
    })));
    this.config = {
      autoConnect: autoConnect,
      connectors: connectors,
      provider: _provider,
      storage: storage,
      webSocketProvider: _webSocketProvider
    };
    this.storage = storage;

    _classPrivateFieldSet(this, _lastUsedConnector, storage === null || storage === void 0 ? void 0 : storage.getItem('wallet'));

    _classPrivateMethodGet(this, _addEffects, _addEffects2).call(this);
  }

  _createClass(Client, [{
    key: "setState",
    value: function setState(updater) {
      var newState = typeof updater === 'function' ? updater(this.store.getState()) : updater;
      this.store.setState(newState, true);
    }
  }, {
    key: "clearState",
    value: function clearState() {
      this.setState(function (x) {
        return _objectSpread(_objectSpread({}, x), {}, {
          connector: undefined,
          data: undefined,
          error: undefined,
          status: 'disconnected'
        });
      });
    }
  }, {
    key: "destroy",
    value: function () {
      var _destroy = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee10() {
        var _this$connector$disco, _this$connector;

        return regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                if (!this.connector) {
                  _context10.next = 3;
                  break;
                }

                _context10.next = 3;
                return (_this$connector$disco = (_this$connector = this.connector).disconnect) === null || _this$connector$disco === void 0 ? void 0 : _this$connector$disco.call(_this$connector);

              case 3:
                _classPrivateFieldSet(this, _isAutoConnecting, false);

                this.clearState();
                this.store.destroy();

              case 6:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10, this);
      }));

      function destroy() {
        return _destroy.apply(this, arguments);
      }

      return destroy;
    }()
  }, {
    key: "autoConnect",
    value: function () {
      var _autoConnect = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee11() {
        var _this2 = this;

        var sorted, connected, _iterator2, _step2, _loop, _ret;

        return regeneratorRuntime.wrap(function _callee11$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                if (!_classPrivateFieldGet(this, _isAutoConnecting)) {
                  _context12.next = 2;
                  break;
                }

                return _context12.abrupt("return");

              case 2:
                _classPrivateFieldSet(this, _isAutoConnecting, true);

                if (this.connectors.length) {
                  _context12.next = 5;
                  break;
                }

                return _context12.abrupt("return");

              case 5:
                // Try last used connector first
                sorted = _classPrivateFieldGet(this, _lastUsedConnector) ? _toConsumableArray(this.connectors).sort(function (x) {
                  return x.id === _classPrivateFieldGet(_this2, _lastUsedConnector) ? -1 : 1;
                }) : this.connectors;
                connected = false;
                _iterator2 = _createForOfIteratorHelper(sorted);
                _context12.prev = 8;
                _loop = /*#__PURE__*/regeneratorRuntime.mark(function _loop() {
                  var connector, isAuthorized, data;
                  return regeneratorRuntime.wrap(function _loop$(_context11) {
                    while (1) {
                      switch (_context11.prev = _context11.next) {
                        case 0:
                          connector = _step2.value;

                          if (!(!connector.ready || !connector.isAuthorized)) {
                            _context11.next = 3;
                            break;
                          }

                          return _context11.abrupt("return", "continue");

                        case 3:
                          _context11.next = 5;
                          return connector.isAuthorized();

                        case 5:
                          isAuthorized = _context11.sent;

                          if (isAuthorized) {
                            _context11.next = 8;
                            break;
                          }

                          return _context11.abrupt("return", "continue");

                        case 8:
                          _context11.next = 10;
                          return connector.connect();

                        case 10:
                          data = _context11.sent;

                          _this2.setState(function (x) {
                            return _objectSpread(_objectSpread({}, x), {}, {
                              connector: connector,
                              chains: connector === null || connector === void 0 ? void 0 : connector.chains,
                              data: data,
                              status: 'connected'
                            });
                          });

                          connected = true;
                          return _context11.abrupt("return", "break");

                        case 14:
                        case "end":
                          return _context11.stop();
                      }
                    }
                  }, _loop);
                });

                _iterator2.s();

              case 11:
                if ((_step2 = _iterator2.n()).done) {
                  _context12.next = 20;
                  break;
                }

                return _context12.delegateYield(_loop(), "t0", 13);

              case 13:
                _ret = _context12.t0;

                if (!(_ret === "continue")) {
                  _context12.next = 16;
                  break;
                }

                return _context12.abrupt("continue", 18);

              case 16:
                if (!(_ret === "break")) {
                  _context12.next = 18;
                  break;
                }

                return _context12.abrupt("break", 20);

              case 18:
                _context12.next = 11;
                break;

              case 20:
                _context12.next = 25;
                break;

              case 22:
                _context12.prev = 22;
                _context12.t1 = _context12["catch"](8);

                _iterator2.e(_context12.t1);

              case 25:
                _context12.prev = 25;

                _iterator2.f();

                return _context12.finish(25);

              case 28:
                // If connecting didn't succeed, set to disconnected
                if (!connected) this.setState(function (x) {
                  return _objectSpread(_objectSpread({}, x), {}, {
                    data: undefined,
                    status: 'disconnected'
                  });
                });

                _classPrivateFieldSet(this, _isAutoConnecting, false);

                return _context12.abrupt("return", this.data);

              case 31:
              case "end":
                return _context12.stop();
            }
          }
        }, _callee11, this, [[8, 22, 25, 28]]);
      }));

      function autoConnect() {
        return _autoConnect.apply(this, arguments);
      }

      return autoConnect;
    }()
  }, {
    key: "setLastUsedConnector",
    value: function setLastUsedConnector() {
      var _this$storage;

      var lastUsedConnector = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      (_this$storage = this.storage) === null || _this$storage === void 0 ? void 0 : _this$storage.setItem('wallet', lastUsedConnector);
    }
  }, {
    key: "chains",
    get: function get() {
      return this.store.getState().chains;
    }
  }, {
    key: "connectors",
    get: function get() {
      return this.store.getState().connectors;
    }
  }, {
    key: "connector",
    get: function get() {
      return this.store.getState().connector;
    }
  }, {
    key: "data",
    get: function get() {
      return this.store.getState().data;
    }
  }, {
    key: "error",
    get: function get() {
      return this.store.getState().error;
    }
  }, {
    key: "lastUsedChainId",
    get: function get() {
      var _this$data, _this$data$chain;

      return (_this$data = this.data) === null || _this$data === void 0 ? void 0 : (_this$data$chain = _this$data.chain) === null || _this$data$chain === void 0 ? void 0 : _this$data$chain.id;
    }
  }, {
    key: "provider",
    get: function get() {
      return this.store.getState().provider;
    }
  }, {
    key: "status",
    get: function get() {
      return this.store.getState().status;
    }
  }, {
    key: "subscribe",
    get: function get() {
      return this.store.subscribe;
    }
  }, {
    key: "webSocketProvider",
    get: function get() {
      return this.store.getState().webSocketProvider;
    }
  }]);

  return Client;
}();

function _addEffects2() {
  var _this3 = this;

  var onChange = function onChange(data) {
    _this3.setState(function (x) {
      return _objectSpread(_objectSpread({}, x), {}, {
        data: _objectSpread(_objectSpread({}, x.data), data)
      });
    });
  };

  var onDisconnect = function onDisconnect() {
    _this3.clearState();
  };

  var onError = function onError(error) {
    _this3.setState(function (x) {
      return _objectSpread(_objectSpread({}, x), {}, {
        error: error
      });
    });
  };

  this.store.subscribe(function (_ref2) {
    var connector = _ref2.connector;
    return connector;
  }, function (connector, prevConnector) {
    var _prevConnector$off, _prevConnector$off2, _prevConnector$off3, _connector$on, _connector$on2, _connector$on3;

    prevConnector === null || prevConnector === void 0 ? void 0 : (_prevConnector$off = prevConnector.off) === null || _prevConnector$off === void 0 ? void 0 : _prevConnector$off.call(prevConnector, 'change', onChange);
    prevConnector === null || prevConnector === void 0 ? void 0 : (_prevConnector$off2 = prevConnector.off) === null || _prevConnector$off2 === void 0 ? void 0 : _prevConnector$off2.call(prevConnector, 'disconnect', onDisconnect);
    prevConnector === null || prevConnector === void 0 ? void 0 : (_prevConnector$off3 = prevConnector.off) === null || _prevConnector$off3 === void 0 ? void 0 : _prevConnector$off3.call(prevConnector, 'error', onError);
    if (!connector) return;
    (_connector$on = connector.on) === null || _connector$on === void 0 ? void 0 : _connector$on.call(connector, 'change', onChange);
    (_connector$on2 = connector.on) === null || _connector$on2 === void 0 ? void 0 : _connector$on2.call(connector, 'disconnect', onDisconnect);
    (_connector$on3 = connector.on) === null || _connector$on3 === void 0 ? void 0 : _connector$on3.call(connector, 'error', onError);
  });
  var _this$config = this.config,
      provider = _this$config.provider,
      webSocketProvider = _this$config.webSocketProvider;
  var subscribeProvider = typeof provider === 'function';
  var subscribeWebSocketProvider = typeof webSocketProvider === 'function';
  if (subscribeProvider || subscribeWebSocketProvider) this.store.subscribe(function (_ref3) {
    var _data$chain2;

    var data = _ref3.data;
    return data === null || data === void 0 ? void 0 : (_data$chain2 = data.chain) === null || _data$chain2 === void 0 ? void 0 : _data$chain2.id;
  }, function (chainId) {
    _this3.setState(function (x) {
      return _objectSpread(_objectSpread({}, x), {}, {
        provider: subscribeProvider ? provider({
          chainId: chainId
        }) : x.provider,
        webSocketProvider: subscribeWebSocketProvider ? webSocketProvider({
          chainId: chainId
        }) : x.webSocketProvider
      });
    });
  });
}

var client;

function createClient(config) {
  var client_ = new Client(config);
  client = client_;
  return client_;
}

function getClient() {
  if (!client) {
    throw new Error('No wagmi client found. Ensure you have set up a client: https://wagmi.sh/docs/client');
  }

  return client;
}

export { Client as C, InjectedConnector as I, createStorage as a, createClient as c, getClient as g, noopStorage as n, shimDisconnectKey as s };